import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './FiltersDrawer.styles';
import { AdOrder } from '@/api/types/ads.types';

interface CatalogueDrawerProps {
  sort: AdOrder;
  setSort: React.Dispatch<React.SetStateAction<AdOrder>>;
}

export const FiltersDrawerSortItems: React.FC<CatalogueDrawerProps> = ({
  sort,
  setSort,
}) => {
  const { t } = useTranslation();

  const sortItems = Object.values(AdOrder).filter(el => el !== AdOrder.Random);

  return (
    <>
      <S.PropertyName $hasTopGutter>{t('common.sorting')}</S.PropertyName>
      <S.OptionButtonsBox $hasBottomGutter>
        {sortItems.map(el => {
          return (
            <S.OptionButton
              id={
                el !== AdOrder.DateDesc
                  ? `order_${el.toLowerCase()}`
                  : undefined
              }
              key={el}
              data-testid="sort-item"
              $isActive={sort === el}
              onClick={() => setSort(el)}
              $isLowercase
            >
              {t(`common.${el.toLowerCase()}`)}
            </S.OptionButton>
          );
        })}
      </S.OptionButtonsBox>
    </>
  );
};
